import { useEffect, useState } from 'react';
import { savedInspectionsStorageV2 } from '@/store/idbStorage/savedInspectionsStorageV2';
import { SWMessageType } from '@/enums/SWMessageType.enum';
import { Inspection } from '@/types/Inspection.type';

export const useStoredInspection = (inspectionId?: string) => {
    const [storedInspection, setStoredInspection] = useState<Partial<Inspection | null>>();

    useEffect(() => {
        let serviceWorkerMsgHandler: (event: MessageEvent) => void;
        const fetchStoredInspection = async (inspectionId: string) => {
            serviceWorkerMsgHandler = (event: MessageEvent) => {
                if (event.data?.type === SWMessageType.UPLOAD_DATA) {
                    // Refresh the list when upload starts
                    fetchStoredInspection(inspectionId);
                }
            }
            try {
                // Get inspections from storage
                const inspection = await savedInspectionsStorageV2.get(inspectionId);
                if (inspection) {
                    setStoredInspection({ locked: inspection.locked, id: inspection.id });
                } else {
                    setStoredInspection(null);
                }

                // Register service worker message listener
                navigator.serviceWorker?.addEventListener('message', serviceWorkerMsgHandler);
            } catch (error) {
                console.error('Failed to fetch stored inspection IDs:', error);
                setStoredInspection(null);
            }
        };
        if (inspectionId) {
            fetchStoredInspection(inspectionId);
        }

        // Cleanup listener on unmount
        return () => {
            if (serviceWorkerMsgHandler) {
                navigator.serviceWorker?.removeEventListener('message', serviceWorkerMsgHandler);
            }
        };
    }, [inspectionId]);

    return storedInspection;
}; 